import { Injectable } from '@angular/core'
import { Break, BreakCodeClipboardEntry } from '../model/break.model'
import { unescapeNoteNewlines } from '../utils/note-formatter'

/** Confirmation shown after a successful copy. */
export const BREAK_CODES_COPIED = 'Break codes copied'

/**
 * An uncoded break can come back as `''` as well as null/undefined, and `''` is never a
 * code resolvePaste could find in a dialog's options — left as-is it would paste as a
 * spurious "some break codes could not be pasted". Truthiness (`||`) not `??` is
 * deliberate here, which is exactly what prefer-nullish-coalescing would push you off.
 */
function emptyToNull(code: string | undefined): string | null {
  return code ? code : null
}

/**
 * Holds the single most recently copied break-code triple, in memory only.
 *
 * Lifetime is deliberately "until page refresh": no TTL timer, no sessionStorage, no
 * cross-tab sync. Root-provided because MultiBreaksContextMenuService is panel-scoped
 * and would drop the clipboard whenever the B&V panel is rebuilt. Never shows a toast
 * itself — it owns the wording (BREAK_CODES_COPIED), the call sites decide when.
 */
@Injectable({ providedIn: 'root' })
export class BreakCodeClipboardService {
  private entry: BreakCodeClipboardEntry | null = null

  copy(brk: Break): void {
    this.entry = {
      actionCode: emptyToNull(brk.actionCode),
      descriptionCode: emptyToNull(brk.descriptionCode),
      note: unescapeNoteNewlines(brk.note),
    }
  }

  read(): BreakCodeClipboardEntry | null {
    return this.entry ? { ...this.entry } : null
  }

  get hasContent(): boolean {
    return this.entry != null
  }
}
